export default __webpack_public_path__ + "static/media/No-Photo-Available.138ef5a5.jpg";